export enum IntegrationWorkflowStatus {
  RUNNING = 'running',
  COMPLETED = 'completed',
}

export type IntegrationWorkflowOutcome = {
  id: number
  name: string | null
  nextStepId: number | null
}

export type IntegrationWorkflowStep = {
  id: number
  name: string | null
  completedAt: string | null
  outcomes: IntegrationWorkflowOutcome[]
}

export type IntegrationWorkflow = {
  id: number
  name: string | null
  description: string | null
  label: string | null
  status: IntegrationWorkflowStatus
  completedAt: string | null
  activeStep: IntegrationWorkflowStep | null
  steps: IntegrationWorkflowStep[]
}

export type IntegrationWorkflowMilestone = {
  id: string
  name: string | null
}

export type IntegrationWorkflowTemplate = {
  id: string
  name: string | null
  description: string | null
  milestones: IntegrationWorkflowMilestone[]
}

export type IntegrationWorkflowCapabilities = {
  stepNote: boolean
}
